import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["accountId", "value", "onChange"];
import { useMemo, useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import { Button } from 'foundations-components/transitional/components/Button';
import { useGetPortalTeamsQuery } from 'academy-common-lib/__generated__/chirp/com/hubspot/learning/center/assignments/rpc/PortalChirpService.hooks';
import { jsx as _jsx } from "react/jsx-runtime";
function convertTeamsToOptions(teams) {
  return teams.map(team => {
    const hasChildren = team.childTeams && team.childTeams.length > 0;
    if (hasChildren) {
      return {
        text: team.teamName,
        selectAll: true,
        options: [{
          text: team.teamName,
          value: team.teamId
        }, ...convertTeamsToOptions(team.childTeams)]
      };
    }
    return {
      text: team.teamName,
      value: team.teamId
    };
  });
}
function getAllTeamValues(options) {
  const values = [];
  options.forEach(option => {
    if (option.value) {
      values.push(option.value);
    }
    if (option.options) {
      values.push(...getAllTeamValues(option.options));
    }
  });
  return values;
}
export const TeamsSelect = _ref => {
  let {
      accountId,
      value,
      onChange
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    data,
    loading
  } = useGetPortalTeamsQuery({
    variables: {
      targetPortalId: accountId || 0
    },
    skip: !accountId
  });
  const teamOptions = useMemo(() => {
    if (!(data !== null && data !== void 0 && data.teams)) return [];
    return convertTeamsToOptions(data.teams);
  }, [data === null || data === void 0 ? void 0 : data.teams]);
  const allTeamValues = useMemo(() => getAllTeamValues(teamOptions), [teamOptions]);
  const hasNoTeams = !loading && teamOptions.length === 0 && Boolean(accountId);
  const areAllSelected = value && value.length === allTeamValues.length && allTeamValues.length > 0;
  const handleSelectAll = useCallback(() => {
    if (onChange) {
      if (areAllSelected) {
        onChange({
          target: {
            value: []
          }
        });
      } else {
        onChange({
          target: {
            value: allTeamValues
          }
        });
      }
    }
  }, [onChange, areAllSelected, allTeamValues]);
  const dropdownFooter = useMemo(() => {
    if (teamOptions.length === 0) return undefined;
    return /*#__PURE__*/_jsx(Button, {
      onClick: handleSelectAll,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: areAllSelected ? 'academyCommon.playlists.deselectAllTeams' : 'academyCommon.playlists.selectAllTeams'
      })
    });
  }, [teamOptions.length, handleSelectAll, areAllSelected]);
  return /*#__PURE__*/_jsx(Select, Object.assign({}, props, {
    anchorType: "button",
    disabled: hasNoTeams || Boolean(props.disabled),
    dropdownFooter: dropdownFooter,
    isLoading: loading,
    multi: true,
    multiCollapseLimit: 10,
    onChange: onChange,
    options: teamOptions,
    placeholder: hasNoTeams ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.playlists.noTeamsInAccount"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.playlists.selectTeamsPlaceholder"
    }),
    value: value
  }));
};